<template>
  <label class="flex cursor-pointer items-start justify-start gap-2">
    <input
      :checked="!!modelValue"
      :disabled="disabled"
      type="checkbox"
      :class="
        checkbox({
          size: 'lg',
          class: 'shrink-0',
        })
      "
      @change="update(($event.target as HTMLInputElement).checked)"
    />
    <span v-if="label">{{ label }}</span>
    <slot v-else />
  </label>
</template>

<script lang="ts" setup>
import { checkbox } from '@carvia/theme/lib/cva/checkbox.ts';

const props = defineProps<{
  modelValue?: boolean | null;
  label?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'change', value: boolean): void;
}>();

const update = (value: boolean) => {
  emit('update:modelValue', value);
  emit('change', value);
};
</script>
